import React, { useState } from "react";
import { Layout} from 'antd';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from '@ant-design/icons';
import { Aside, Headers } from "../../components";
const {Content } = Layout;

const AdminLayout = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  const toogle = () => {
      setCollapsed(!collapsed);
  }
  return (
    <Layout>
      <Aside collapsed={collapsed} />
      <Layout className='site-layout'>
        <Headers
          toogle={toogle}
          collapsed={collapsed}
          MenuUnfoldOutlined={MenuUnfoldOutlined}
          MenuFoldOutlined={MenuFoldOutlined}
        />
        <Content
          className='site-layout-background'
          style={{
            margin: '10px 16px',
            padding: '10px 16px',
            minHeight: '85vh',
          }}
        >
          {props.content}
        </Content>
      </Layout>
    </Layout>
  );
}

export default AdminLayout